/* eslint-disable max-len */

import { RECURRENCE_NAMESPACE } from '@pflegix/i18n';

export const ORDER_HEADER_DATA_TRANSLATION_DE = {
  duration_one: '{{count}} Stunde',
  duration_other: '{{count}} Stunden',
  visit_one: '{{count}} Besuch',
  visit_other: '{{count}} Besuche',
  period: '{{startAt, datetime}} - {{endAt, datetime}}',
  period_open_end: '{{startAt, datetime}} - Ende offen',
  frequency: `$t(${RECURRENCE_NAMESPACE}:{{rhythm, lowercase}}) $t(visit, {"count": {{visits}} }) für $t(duration, {"count": {{duration}} })`,
} as const;
